import edgeAnalyticsApi from '@Apis/edgeAnalytics.api';
import {
	SensorsUptimeResponse,
	SensorsLatestDataRequest,
	SensorsLatestDataResponse,
	SensorsUptimeDataRequest,
} from '@Types/edgeAnalytics.types';

/**
 * @ deprecated
 */
export const getSensorsHealthStatusLegacy = (sensorsIds: string[]) => {
	const query = sensorsIds.map(sensorId => ({
		sensorId: sensorId,
		upTimePercentages: [
			{
				timePart: 'HOUR',
				sliceLength: '24',
			},
		],
	}));
	const body = { query };
	return edgeAnalyticsApi.post<SensorsUptimeResponse>('uptime', body);
};

/**
 * @ deprecated
 */
export const getSensorHealthTrendLegacy = (sensorId: string) => {
	const query = [
		{
			sensorId,
			upTimePercentages: [
				{
					timePart: 'HOUR',
					sliceLength: '1',
				},
				{
					timePart: 'HOUR',
					sliceLength: '8',
				},
				{
					timePart: 'HOUR',
					sliceLength: '24',
				},
				{
					timePart: 'DAY',
					sliceLength: '7',
				},
			],
		},
	];
	const body = { query };
	return edgeAnalyticsApi.post<SensorsUptimeResponse>('uptime', body);
};

export const getSensorHealthTrend = (sensors: SensorsLatestDataRequest[]) => {
	const upTimePercentages = [
		{
			timePart: 'HOUR',
			sliceLength: 1,
		},
		{
			timePart: 'HOUR',
			sliceLength: 8,
		},
		{
			timePart: 'HOUR',
			sliceLength: 24,
		},
		{
			timePart: 'DAY',
			sliceLength: 7,
		},
	];

	const query = {
		sensors,
		upTimePercentages,
	};

	return edgeAnalyticsApi.post<SensorsUptimeResponse>('sensor-health', {
		query,
	});
};

export const getSensorsHealthStatus = (sensors: SensorsUptimeDataRequest[]) => {
	const upTimePercentages = [
		{
			timePart: 'HOUR',
			sliceLength: 24,
		},
	];

	const body = {
		query: {
			sensors,
			upTimePercentages,
		},
	};
	return edgeAnalyticsApi.post<SensorsUptimeResponse>('sensor-health', body);
};

export const getSensorsLatestData = (sensors: SensorsLatestDataRequest[]) => {
	return edgeAnalyticsApi.post<SensorsLatestDataResponse>('latest-measures', {
		query: sensors,
	});
};
